import { render, staticRenderFns } from "./BottomTabbar.vue?vue&type=template&id=7d647b47&"
import script from "./BottomTabbar.vue?vue&type=script&lang=js&"
export * from "./BottomTabbar.vue?vue&type=script&lang=js&"
import style0 from "./BottomTabbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports